module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "notification",
    on: {
      "click": function($event) {
        _vm.openNews(_vm.lastArticle)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rss"
  }), _vm._v(" " + _vm._s(_vm.lastArticle.title) + "\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7e5e6ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notification.vue
// module id = 350
// module chunks = 1